
(() => {
  if (window.lxImagePopupInitialized) return;
  window.lxImagePopupInitialized = true;

  const popup = document.createElement('div');
  popup.className = 'lx-image-popup';
  popup.innerHTML = `
    <button type="button" class="lx-image-popup__close"
      aria-label="Close">&times;</button>
    <img class="lx-image-popup__image" alt="Image preview">
  `;

  document.body.appendChild(popup);

  const img = popup.querySelector('img');
  const close = popup.querySelector('button');
 
let scale = 1;
let posX = 0;
let posY = 0;
let startX = 0;
let startY = 0;
let startPosX = 0;
let startPosY = 0;
let dragging = false;

function updateImage() {
  img.style.transform =
    `translate(${posX}px, ${posY}px) scale(${scale})`;
}

function resetZoom() {
  scale = 1;
  posX = 0;
  posY = 0;
  img.classList.remove('is-zoomed', 'is-dragging');
  updateImage();
}

img.addEventListener('click', () => {
  if (dragging) return;

  if (scale === 1) {
    scale = 2;
    img.classList.add('is-zoomed');
  } else {
    resetZoom();
  }

  updateImage();
});

img.addEventListener('pointerdown', (event) => {
  if (scale === 1) return;

  dragging = true;
  startX = event.clientX;
  startY = event.clientY;
  startPosX = posX;
  startPosY = posY;

  img.classList.add('is-dragging');
  img.setPointerCapture(event.pointerId);
  event.preventDefault();
});

img.addEventListener('pointermove', (event) => {
  if (!dragging) return;

  posX = startPosX + event.clientX - startX;
  posY = startPosY + event.clientY - startY;

  updateImage();
});

function stopDragging() {
  dragging = false;
  img.classList.remove('is-dragging');
}

img.addEventListener('pointerup', stopDragging);
img.addEventListener('pointercancel', stopDragging);

img.addEventListener('load', resetZoom);


  function closePopup() {
    popup.classList.remove('is-open');
    document.body.classList.remove('lx-image-popup-active');
    img.removeAttribute('src');
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest(
      '.lx-pr-accordion .lx-image-popup-content a[href]'
    );

    if (!link) return;

    const url = new URL(link.href, window.location.href);

    if (!/\.(png|jpe?g|webp|gif|avif)$/i.test(url.pathname)) return;

    event.preventDefault();
    img.src = url.href;
    popup.classList.add('is-open');
    document.body.classList.add('lx-image-popup-active');
  });

  close.addEventListener('click', closePopup);

  popup.addEventListener('click', (event) => {
    if (event.target === popup) closePopup();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePopup();
  });
})();
